<div id="desktop">
  <app-nav-menu></app-nav-menu>
  <main id="main-content">
    <section class="hero" id="top">
      <div class="page-shell hero__banner">
        <img class="hero__banner-image" src="../../../assets/images/main graphic 2.png" alt="Did you use a GoodRx website, app, or service prior to April 20, 2024? You may be eligible for a payment from a $32 million class action settlement.">
        <a class="hero__banner-cta" [routerLink]="['/file-not-noticed']" id="claim" aria-label="File a claim">
          <img src="../../../assets/images/CTA button.png" alt="">
        </a>
      </div>
    </section>

    <section class="info-cards section" id="about">
      <div class="page-shell info-cards__grid">
        <div class="info-cards__stack">
          <article class="info-card">
            <img class="info-card__icon" src="../../../assets/images/people icon.png" alt="" aria-hidden="true">
            <div class="info-card__body">
              <h3>Who is a member of the Settlement Class?</h3>
              <p>
                Subject to certain exceptions, the proposed Settlement Class consists of all natural persons in the United
                States who used any website, app, or service made available by or through GoodRx at any time prior to
                April 20, 2024.
                If you are not sure whether you are included in the Settlement Class, you can find additional information,
                including the detailed <b><u><a href="../../../assets/docs/GoodRx Criteo - Long Form Notice V2.pdf" target="_blank" style="color:inherit">Notice</a></u></b> and the <b><u><a href="../../../assets/docs/Settlement Agreement.pdf" target="_blank" style="color:inherit">Settlement Agreement</a></u></b> on this website.
              </p>
            </div>
          </article>
          <article class="info-card">
            <img class="info-card__icon" src="../../../assets/images/paper icon.png" alt="" aria-hidden="true">
            <div class="info-card__body">
              <h3>What is this lawsuit about and what does the Settlement provide?</h3>
              <p>
                GoodRx is a combination telehealth and prescription coupon company that provides millions of people with
                telehealth services, coupons for prescription medication, and other health-related services each month.
                When people use GoodRx’s services, GoodRx collects their personal and health information, including
                information about their prescription medications and health conditions, email addresses, and phone
                numbers. Plaintiffs allege that between at least 2017 and 2020, GoodRx disclosed this sensitive personal
                and health information to advertising and analytics companies, including Criteo, Meta Platforms, Inc. (f/k/a
                Facebook, Inc.) (“Meta”) and Google LLC (“Google” and with Meta, “Remaining Defendants”) through
                GoodRx’s incorporation of the Criteo and Remaining Defendants’ technologies (i.e., software development
                kits (“SDKs”) and JavaScript pixels (“Pixels”)) on the GoodRx platform. Such disclosed data included any
                data or information related to a Person’s use of websites, applications, or services made available by or
                through GoodRx, including GoodRx’s website and app, GoodRx Gold, HeyDoctor, and GoodRx Care, and
                including but not limited to data or information that is or could be used, whether on its own or in
                combination with other information, to identify, locate, recognize, reach, or contact a person or device.
                Plaintiffs also allege that Remaining Defendants and Criteo used this information for their own purposes.
              </p>
            </div>
          </article>
          <article class="info-card">
            <img class="info-card__icon" src="../../../assets/images/money icon.png" alt="" aria-hidden="true">
            <div class="info-card__body">
              <h3>Will I get a payment?</h3>
              <p>
                If you are a member of the Settlement Class and do not opt out, you may be eligible for a payment under
                the Settlement if you file a <b><u><a href="../../../assets/docs/GoodRx Criteo Claim Form Draft V3 - Blank.pdf" target="_blank" style="color:inherit">Claim Form</a></u></b>. Claim Forms must be postmarked by <b>December 29, 2026</b> or
                submitted online <b><u><a [routerLink]="['/file-not-noticed']" style="color:inherit">HERE</a></u></b> on or before 11:59 p.m. Eastern Time on <b>December 29, 2026</b>.
              </p>
            </div>
          </article>
        </div>

        <div class="dates-card">
          <img src="../../../assets/images/Dates section.png" alt="Important Dates: Claim Deadline December 29, 2026; Opt Out Deadline December 29, 2026; Objection Deadline December 29, 2026; Final Approval Hearing February 11, 2027.">
          <a class="dates-card__link" href="#your-rights" aria-label="View all class members, options and deadlines">View All Class Members<br>Options and Deadlines</a>
        </div>
      </div>
    </section>

    <section class="claim-band">
      <div class="page-shell claim-band__inner">
        <img class="claim-band__icon" src="../../../assets/images/phone icon.png" alt="" aria-hidden="true">
        <img class="claim-band__text" src="../../../assets/images/claim text.png" alt="How do I file a claim? It's easy to file a claim. To receive a payment, you must complete and timely submit a valid claim form by December 29, 2026.">
        <a class="claim-band__cta" [routerLink]="['/file-not-noticed']" id="claim" aria-label="File a claim">
          <img src="../../../assets/images/CTA button green.png" alt="">
        </a>
      </div>
    </section>

    <section class="rights-section" id="your-rights">
      <div class="page-shell">
        <h2 class="rights-section__title">Your Legal Rights and Options in This Settlement</h2>
        <div class="rights-section__grid">
          <div class="rights-option">
            <a [routerLink]="['/file-not-noticed']" aria-label="File a claim">
              <img class="rights-option__icon" src="../../../assets/images/claim icon.png" alt="" aria-hidden="true">
            </a>
            <h3 class="rights-option__heading"><a [routerLink]="['/file-not-noticed']">Submit<br>a Claim Form</a></h3>
            <p class="rights-option__text">
              Get a payment if you’re eligible.
            </p>
          </div>
          <div class="rights-option">
            <img class="rights-option__icon" src="../../../assets/images/exclude icon.png" alt="" aria-hidden="true">
            <h3 class="rights-option__heading">Exclude<br>Yourself</h3>
            <p class="rights-option__text">
              Exclude yourself. Receive no payment from the Settlement but retain your right to sue GoodRx and Criteo.
            </p>
          </div>
          <div class="rights-option">
            <img class="rights-option__icon" src="../../../assets/images/object icon.png" alt="" aria-hidden="true">
            <h3 class="rights-option__heading">Object</h3>
            <p class="rights-option__text">
              File a written objection with the Court about the Settlement and/or the proposed attorneys' fee, expenses and service awards.
            </p>
          </div>
          <div class="rights-option">
            <img class="rights-option__icon" src="../../../assets/images/Hearing icon.png" alt="" aria-hidden="true">
            <h3 class="rights-option__heading">Attend<br>Final Hearing</h3>
            <p class="rights-option__text">
              Attend the Final Approval Hearing at your own expense. File a written objection if you want to speak at the hearing.
            </p>
          </div>
          <div class="rights-option">
            <img class="rights-option__icon" src="../../../assets/images/do nothing icon.png" alt="" aria-hidden="true">
            <h3 class="rights-option__heading">Do Nothing</h3>
            <p class="rights-option__text">
              Get no payment from the Settlement, but you remain a Class Member and are bound by the Settlement's terms.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="contact-info">
      <div class="page-shell">
        <p>
          If you have questions or want more information,<br>
          you may call or you may contact the Settlement Administrator by email, or by writing to:<br>
          GoodRx Data Disclosure Settlement<br>
          c/o A.B. Data, Ltd.<br>
          PO Box 173138<br>
          Milwaukee, WI 53217<br>
          Toll Free: 1-877-888-9232<br>
          Email: <a href="mailto:info@goodrxprivacysettlement.com">info@goodrxprivacysettlement.com</a>
        </p>
      </div>
    </section>

  
  </main>
</div>













